import React, { Component } from 'react'
import classNames from 'classnames'
import { Flag } from '@everlane/icon'
import { getCountryCode, getCountryName, localizationAware } from 'base/lib/localization'

class CurrentCountryDisplay extends Component {
  renderCountryText() {
    if (this.props.compact) {
      return (
        <span className="current-country-display__text">{this.props.localization.currency}</span>
      )
    } else {
      return (
        <React.Fragment>
          <span className="current-country-display__text">{getCountryName()}</span>
          <span className="current-country-display__text">
            ({this.props.localization.currency})
          </span>
        </React.Fragment>
      )
    }
  }

  render() {
    if (!this.props.localization) {
      return null
    }

    return (
      <div
        className={`current-country-display ${
          this.props.compact ? 'current-country-display--compact' : ''
        }`}
        onClick={this.props.onClickCountryDisplay}
      >
        <Flag
          className={classNames('current-country-display__flag', this.props.flagClassName)}
          countryCode={getCountryCode()}
        />
        {this.renderCountryText()}
      </div>
    )
  }
}

export default localizationAware(CurrentCountryDisplay)
